import CartPaymentPage from "./CartPaymentPage";

export default CartPaymentPage;
